// Presentation only: room names, guest names, API statuses and identifiers stay unchanged.
export const OCCUPANCY_GRID_SPANISH = {
  "Occupancy Grid": "Parrilla de ocupación",
  "Room inventory and stays across the selected operating window": "Inventario de habitaciones y estancias en el período seleccionado",
  "Reservations": "Reservas",
  "Occupancy grid summary": "Resumen de la parrilla de ocupación",
  "of": "de",
  "stays and blocks in range": "estancias y bloqueos en el período",
  "room categories": "categorías de habitación",
  "room category": "categoría de habitación",
  "{count} categories with overbooking in selected range": "{count} categorías con sobreventa en el período seleccionado",
  "{count} category with overbooking in selected range": "{count} categoría con sobreventa en el período seleccionado",
  "No overbooking in selected range": "Sin sobreventa en el período seleccionado",
  "{count} room assignment updates queued": "{count} asignaciones de habitación pendientes",
  "{count} room assignment update queued": "{count} asignación de habitación pendiente",
  "No dates selected": "Sin fechas seleccionadas",
  "{count} days": "{count} días",
  "{count} day": "{count} día",
  "Read only. You can explore dates and reservations; room assignment is disabled.": "Solo consulta. Puedes explorar fechas y reservas; la asignación de habitaciones está desactivada.",
  "View": "Vista",
  "Open": "Ver",
  "Occupancy layout": "Vista de la parrilla de ocupación",
  "Lanes": "Disponibilidad",
  "Room numbers": "Números de habitación",
  "From": "Desde",
  "To": "Hasta",
  "Today": "Hoy",
  "Occupancy grid legend": "Leyenda de la parrilla de ocupación",
  "Legend": "Leyenda",
  "Reservation": "Reserva",
  "In house": "Alojados",
  "Room block": "Bloqueo de habitación",
  "Room Block": "Bloqueo de habitación",
  "Room not assigned": "Habitación sin asignar",
  "Overbooking": "Sobreventa",
  "Loading occupancy grid...": "Cargando la parrilla de ocupación...",
  "Select a valid date range.": "Selecciona un período válido.",
  "No reservations found.": "No se han encontrado reservas.",
  "Room Category": "Categoría de habitación",
  "Inventory": "Inventario",
  "Availability lanes": "Filas de disponibilidad",
  "Room": "Habitación",
  "Number": "Número",
  "Lane": "Fila",
  "Room {number}": "Habitación {number}",
  "Category {id}": "Categoría {id}",
  "Overflow {number}": "Sobreventa {number}",
  "in selected range": "en el período seleccionado",
  "Unassigned reservations": "Reservas sin habitación asignada",
  "Close panel": "Cerrar panel",
  "Read only. Open a reservation to view its details.": "Solo consulta. Abre una reserva para ver su detalle.",
  "Drag each reservation to a room row, or assign directly from the selector.": "Arrastra cada reserva a la fila de una habitación o asígnala directamente desde el selector.",
  "Loading available room numbers...": "Cargando habitaciones disponibles...",
  "No unassigned reservations left for this day.": "No quedan reservas sin habitación asignada para este día.",
  "Open reservation {name}": "Abrir reserva {name}",
  "Drag {name} to a room row": "Arrastrar {name} a la fila de una habitación",
  "Drag": "Arrastrar",
  "to": "a",
  "Room suggested:": "Habitación sugerida:",
  "Read only": "Solo consulta",
  "Drag this capsule into a room": "Arrastra esta reserva a una habitación",
  "Room assignment is disabled in the demo": "Asignación desactivada en la demo",
  "No available room": "No hay habitaciones disponibles",
  "Select a room": "Selecciona una habitación",
  "Room for {name}": "Habitación para {name}",
  "Assign": "Asignar",
  "Waitlist": "Lista de espera",
  "Waitlist · {name}": "Lista de espera · {name}",
  ", +{count} more": ", +{count} más",
  "Overbooking {date}: {count} reservations without room. {names}{suffix}": "Sobreventa {date}: {count} reservas sin habitación. {names}{suffix}",
  "Overbooking {date}: {count} reservation without room. {names}{suffix}": "Sobreventa {date}: {count} reserva sin habitación. {names}{suffix}",
  "Unassigned room number {date}: {count} reservations. {names}{suffix}": "Sin habitación asignada {date}: {count} reservas. {names}{suffix}",
  "Unassigned room number {date}: {count} reservation. {names}{suffix}": "Sin habitación asignada {date}: {count} reserva. {names}{suffix}",
  "Moved from {room} on {date}": "Traslado desde {room} el {date}",
  "Moves to {room} on {date}": "Traslado a {room} el {date}",
  "Moved from room {room}": "Traslado desde la habitación {room}",
  "Moves to room {room}": "Traslado a la habitación {room}",
  "IN": "ENT.",
  "OUT": "SAL.",
  "Operation failed.": "No se ha podido completar la operación. Inténtalo de nuevo.",
  "Could not load available room numbers for one or more reservations.": "No se han podido cargar las habitaciones disponibles para una o varias reservas.",
  "Room assignment is not available in this context.": "La asignación de habitaciones no está disponible en esta vista.",
  "That room is not available for the full reservation range.": "Esa habitación no está disponible durante toda la estancia.",
  "Could not assign this room.": "No se ha podido asignar esta habitación.",
  "Could not prepare this assignment.": "No se ha podido preparar esta asignación.",
  "You can only move reservations inside the same room category.": "Solo puedes mover reservas dentro de la misma categoría de habitación.",
  "Cannot assign a reservation to a blocked room.": "No se puede asignar una reserva a una habitación bloqueada.",
  "Could not move reservation.": "No se ha podido mover la reserva.",
  "Drop on a day included in the reservation range.": "Suelta la reserva en un día incluido en su estancia.",
  "Could not unassign this reservation.": "No se ha podido quitar la habitación asignada a esta reserva.",
};
